module.exports = __webpack_public_path__ + "assets/img/23_30.e166a1c6.jpg";